import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  width: 100%;
  padding: 4rem 2rem;
`;

const Image = styled.img`
  margin-top: 3rem;
  opacity: 0.9;
  margin-left: 1rem;
  max-width: 35rem;
  object-fit: cover;

  @media (max-width: 500px) {
    max-width: 100%;
  }
`;

const Text = styled.p`
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--ink-soft);
  text-align: center;
`;

export { Container, Image, Text };
